// extracted by mini-css-extract-plugin
export var styles = "block-module--styles--3x3nK";
export var zzz = "block-module--zzz--35d83";